var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVisibleLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120.449,
    height: 120.449,
    viewBox: "0 0 120.449 120.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3446",
    "data-name": "Group 3446",
    transform: "translate(-593 -16728)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 59,
    cy: 59,
    r: 59,
    transform: "translate(594 16729)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dot-12",
    d: "M224.364,141.992a60.567,60.567,0,0,1,0,60.466,60.056,60.056,0,0,1-21.907,21.907,60.567,60.567,0,0,1-60.466,0,60.023,60.023,0,0,1-21.922-21.922,60.588,60.588,0,0,1,.015-60.451,60.023,60.023,0,0,1,21.922-21.922,60.588,60.588,0,0,1,60.451.015A60.17,60.17,0,0,1,224.364,141.992Zm-30.73-6.685a42.92,42.92,0,0,0-42.82,0,42.4,42.4,0,0,0-15.523,15.523,42.92,42.92,0,0,0,0,42.82,42.4,42.4,0,0,0,15.523,15.523,42.92,42.92,0,0,0,42.82,0,42.4,42.4,0,0,0,15.523-15.523,42.92,42.92,0,0,0,0-42.82A42.632,42.632,0,0,0,193.635,135.307Zm-7.212,22.735a20.065,20.065,0,1,1-14.2-5.887A19.338,19.338,0,0,1,186.423,158.042Z",
    transform: "translate(481 16616)",
    fill: "#021724"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibleLine);
export default __webpack_public_path__ + "static/media/icon_visible_line.e5ffdcf8480ca75291b4679fda5850f2.svg";
export { ForwardRef as ReactComponent };